export const WEB_VERSION = 'v1.0';
